import { render } from "./MetricsView.vue?vue&type=template&id=6b8207a6&scoped=true"
import script from "./MetricsView.vue?vue&type=script&lang=js"
export * from "./MetricsView.vue?vue&type=script&lang=js"

import "./MetricsView.vue?vue&type=style&index=0&id=6b8207a6&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8207a6"]])

export default __exports__